import { render, staticRenderFns } from "./UploadImageArea.vue?vue&type=template&id=61d530ce&"
import script from "./UploadImageArea.vue?vue&type=script&lang=js&"
export * from "./UploadImageArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports